import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { api } from '../services/api';
import logo from '../assets/logo.png';
import './Login.css';

function Login() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const checkAuth = async () => {
    try {
      const response = await api.get('/auth/me');
      if (response.data.authenticated) {
        navigate('/dashboard');
      }
    } catch (error) {
      // Not authenticated, stay on login page
      // Only log if it's not a network error (backend might not be running)
      if (error.response) {
        console.log('Not authenticated');
      }
    }
  };

  useEffect(() => {
    // Check if user is already authenticated
    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoogleLogin = async () => {
    try {
      setLoading(true);
      setError(null);
      
      const response = await api.get('/auth/google/login');
      if (response.data.authUrl) {
        // Redirect to Google OAuth
        window.location.href = response.data.authUrl;
      }
    } catch (error) {
      setError(error.response?.data?.error || 'Failed to initiate login');
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img 
          src={logo} 
          alt="Email Agent Logo" 
          style={{ 
            width: '80px', 
            height: '80px', 
            objectFit: 'contain',
            margin: '0 auto 16px auto',
            display: 'block'
          }}
        />
        <h1>Email Agent</h1>
        <p className="subtitle">AI-powered email management with Gmail and Calendar</p>
        
        {error && <div className="error">{error}</div>}
        
        <button 
          className="btn-google"
          onClick={handleGoogleLogin}
          disabled={loading}
        >
          {loading ? (
            'Connecting...'
          ) : (
            <>
              <svg className="google-icon" viewBox="0 0 24 24">
                <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
              </svg>
              Sign in with Google
            </>
          )}
        </button>
        
        <div className="info-box">
          <h3>Permissions Required</h3>
          <ul>
            <li>Read Gmail messages</li>
            <li>Create Gmail drafts</li>
            <li>Access Google Calendar events</li>
          </ul>
          <p className="note">We will never send emails without your confirmation.</p>
        </div>

        <div className="login-footer">
          <p>
            By signing in, you agree to our{' '}
            <Link to="/terms" className="footer-link">Terms of Service</Link>
            {' '}and{' '}
            <Link to="/privacy" className="footer-link">Privacy Policy</Link>.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Login;
